(() => {
  const initializeEditorialProducts = (root = document) => {
    root.querySelectorAll(".product-editorial").forEach((section) => {
      if (section.dataset.initialized === "true") return;

      section.dataset.initialized = "true";

      const form = section.querySelector(".product-editorial__form");
      const variantInput = section.querySelector("[data-variant-id]");
      const priceElement = section.querySelector("[data-product-price]");
      const buttonPrice = section.querySelector("[data-button-price]");
      const addButton = section.querySelector("[data-add-to-cart]");
      const variantsElement = section.querySelector("[data-editorial-variants]");

      if (!form || !variantInput || !variantsElement) return;

      let variants = [];

      try {
        variants = JSON.parse(variantsElement.textContent);
      } catch (error) {
        console.error(
          "PLOT & PIN: Could not read product variants.",
          error
        );
        return;
      }

      const getSelectedOptions = () => {
        return Array.from(
          section.querySelectorAll(
            '.product-editorial__option input[type="radio"]:checked'
          )
        ).map((input) => input.value);
      };

      const findVariant = () => {
        const selectedOptions = getSelectedOptions();

        if (!selectedOptions.length) {
          return (
            variants.find((variant) => variant.available) ||
            variants[0] ||
            null
          );
        }

        return (
          variants.find((variant) => {
            return variant.options.every(
              (option, index) => option === selectedOptions[index]
            );
          }) || null
        );
      };

      const formatMoney = (cents) => {
        const amount = Number(cents || 0) / 100;

        const currency =
          window.Shopify?.currency?.active || "INR";

        return new Intl.NumberFormat(
          document.documentElement.lang || "en-IN",
          {
            style: "currency",
            currency: currency
          }
        ).format(amount);
      };

      const updateVariant = () => {
        const variant = findVariant();

        if (!variant) {
          if (addButton) {
            addButton.disabled = true;

            const label =
              addButton.querySelector("[data-button-label]");

            if (label) {
              label.textContent = "UNAVAILABLE";
            }
          }

          return;
        }

        variantInput.value = variant.id;

        if (priceElement) {
          priceElement.textContent = formatMoney(variant.price);
        }

        if (buttonPrice) {
          buttonPrice.textContent = formatMoney(variant.price);
        }

        if (addButton) {
          const label =
            addButton.querySelector("[data-button-label]");

          if (variant.available) {
            addButton.disabled = false;

            if (label) {
              label.textContent = "ADD TO CART";
            }
          } else {
            addButton.disabled = true;

            if (label) {
              label.textContent = "SOLD OUT";
            }
          }
        }

        form.dispatchEvent(
          new CustomEvent("editorial:variant-change", {
            bubbles: true,
            detail: {
              variant: variant
            }
          })
        );
      };

      section
        .querySelectorAll(
          '.product-editorial__option input[type="radio"]'
        )
        .forEach((input) => {
          input.addEventListener("change", updateVariant);
        });

      updateVariant();


      /* =========================================
         PRODUCT IMAGE REVEAL
      ========================================== */

      const revealElements =
        section.querySelectorAll(
          "[data-editorial-reveal]"
        );

      const info =
        section.querySelector(
          ".product-editorial__info-inner"
        );

      if ("IntersectionObserver" in window) {
        const observer =
          new IntersectionObserver(
            (entries, observerInstance) => {

              entries.forEach((entry) => {

                if (!entry.isIntersecting) return;

                entry.target.classList.add(
                  "is-visible"
                );

                observerInstance.unobserve(
                  entry.target
                );

              });

            },
            {
              threshold: 0.08
            }
          );

        revealElements.forEach((element) => {
          observer.observe(element);
        });

        if (info) {
          observer.observe(info);
        }

      } else {

        revealElements.forEach((element) => {
          element.classList.add("is-visible");
        });

        if (info) {
          info.classList.add("is-visible");
        }

      }

    });
  };


  /* =========================================
     INITIAL LOAD
  ========================================== */

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      initializeEditorialProducts();
    }
  );


  /* =========================================
     SHOPIFY THEME EDITOR
  ========================================== */

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initializeEditorialProducts(
        event.target
      );
    }
  );

})();